import axios from "axios";

class ApiError extends Error {
    constructor(response) {
        super(response.statusText);
        this.response = response;
    }
}

export default {
    handleErrors(response) {
        if (!response.ok)
            throw response;
        return response;
    },
    getUser(username) {
        return fetch(`https://www.reddit.com/user/${username}/about.json`)
            .then(this.handleErrors)
            .then(r => r.json())
            .then(d => d.data);
    },
    getHistory(username, after) {
        return this.getCached(username, after).then(cached => {
            return cached || this.getHistoryNetwork(username, after);
        }).then(r => r.json())
            .then(d => d.data);
    },

    getHistoryNetwork(username, after) {
        return fetch(`https://www.reddit.com/user/${username}.json?count=25&after=${after}`)
            .then(this.handleErrors)
            .then(r => {
                this.putCache(username, after, r.clone())
                return r;
            })
    },

    clearCache(username) {
        return this.openCache(username).then(cache => {
            if (cache !== null)
                return cache.keys().then(keys => {
                    return keys.forEach(key => {
                        return cache.delete(key)
                    })
                })
            return null;
        });
    },

    getCached(username, after) {
        return this.openCache(username).then(cache => {
            if (cache !== null)
                return cache.match(after).then(cached => {
                    return cached;
                });
            return null;
        })
    },

    putCache(username, after, response) {
        return this.openCache(username).then(cache => {
            if (cache !== null)
                cache.put(after, response);
        })
    },

    openCache(username) {
        if (window.caches === undefined)
            return new Promise(() => {
                return null;
            });
        return caches.open(username);
    }
}